var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeftInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "R\\xE9teg_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.3 21.7",
    style: {
      enableBackground: "new 0 0 25.3 21.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#DADDE0;stroke-width:3;stroke-linecap:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.201 19.607) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.743) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0,
    y1: -4.2,
    x2: 8.7,
    y2: -13
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.7-13l8.7,8.7"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0,
    y1: 8.7,
    x2: 19.8,
    y2: 8.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftInactive);
export default __webpack_public_path__ + "static/media/arrowLeftInactive.0a371c8d6685703570af3a65f96edf91.svg";
export { ForwardRef as ReactComponent };